// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createHook, type Action } from '@atlassian/react-sweet-state';

export type State = {
	isInitialLoad: boolean;
};

const initialState: State = {
	isInitialLoad: true,
};

export const actions = {
	clearInitialLoaded:
		(): Action<State> =>
		({ setState, getState }) => {
			if (getState().isInitialLoad) {
				setState({
					isInitialLoad: false,
				});
			}
		},
} as const;

export type Actions = typeof actions;

const store = createStore<State, Actions>({
	name: 'is-initial-load-create-issue-legacy',
	initialState,
	actions,
});

export const useIsInitialLoadLegacyIssueCreate = createHook(store);
